(function() {
  var CarouselView, PhotosView, PhotosModalView, PhotosRouter;

  // requires that you implement "carousel"
  CarouselView =
  Backbone.View.extend({
    prev: function() { this.carousel('prev'); },
    next: function() { this.carousel('next'); },

    // slideshow lazy-loader for both mini-slideshow and full blown modal, works on any carousel
    // expectation is you use "lazy-src" attribute instead of "src" attribute on images you want
    // lazy-loaded
    imageLoader: function() {
      var $active = this.$('.active.item');
      var $imgs = $active.add($active.next('.item')).add($active.prev('.item')).find('img.ss_img');
      $imgs.each(function() {
        var lazy = $(this).data('lazy-src');
        if(lazy && !$(this).attr('src')) {
          $(this).attr('src', lazy);
        }
      });
    },
    activePhotoId: function() {
      return this.$('.item.active img.ss_img').data('photo-id');
    },
    highlightActiveOnMap: function() {
      if(!Routes || !Routes.activeMap) return;
      var photoId = this.activePhotoId();
      if(Routes.activeMap.selectedImageMarker) {
        Routes.activeMap.selectedImageMarker.setIcon('/images/image_marker.png?1');
        Routes.activeMap.selectedImageMarker.selected = false;
      }
      if(Routes.activeMap.imageMarkers && Routes.activeMap.imageMarkers[photoId]) {
        Routes.activeMap.imageMarkers[photoId].setIcon('/images/image_marker_selected.png?1');
        Routes.activeMap.selectedImageMarker = Routes.activeMap.imageMarkers[photoId];
        Routes.activeMap.selectedImageMarker.selected = true;
      }
    },
    processPhotos: function(photos) {
      return _.map(photos, function(photo) {
        if(photo.captured_at && _.isString(photo.captured_at)) {
          photo.captured_at = rwgps.DateExt.parse(photo.captured_at, true);
        }
        return photo;
      });
    }
  });

  PhotosView =
  CarouselView.extend({
    id: function() { return _.uniqueId("photosview_"); },
    className: 'photosview_mini',
    template: rwgps.templates.photos.miniSlideshow,
    indicatorTemplate: rwgps.templates.photos.miniSlideshowIndicator,
    itemTemplate: rwgps.templates.photos.miniSlideshowItem,
    uploaderTemplate: rwgps.templates.photos.uploader,
    initialize: function() {
      _.bindAll(this, 'imageLoader', 'highlightActiveOnMap', 'showTooltipIfMouseover', 'showPhotoById');
      this.canEdit = this.options.canEdit;
      this.carouselId = _.uniqueId("photosview_");
      this.photosetId = this.options.photosetId;
      this.photos = this.processPhotos(this.options.photos);
      this.modalView = new PhotosModalView({photosView: this, modal: !this.options.inline, photosetId: this.photosetId, parentType: this.options.parentType, parentId: this.options.parentId});
      this.modalView.render();

      if(this.options.inline) {
        $(this.options.container).html(this.modalView.$el);
      } else {
        this.modalView.$el.appendTo('body');
        this.render();
        $(this.options.container).html(this.$el);
      }

      if(this.canEdit && !this.options.hideUploader)
        this.setupUploader();
      reloadTooltips();

      if(this.options.coverId) {
        _.each(this.photos, function(photo, i) {
          if(photo.id == this.options.coverId) {
            if(this.options.inline)
              this.modalView.carousel(i);
            else
              this.carousel(i);
          }
        }, this);
      }

      PhotosView.registerPhotos(this.photos, this, this.options.noClobber);

      _.defer(function () {
        if(!Backbone.History.started)
          Backbone.history.start();
      });
    },
    events: {
      'click .carousel-control.left': 'prev',
      'click .carousel-control.right': 'next',
      'click .popup_photo_modal': 'showModal',
      'mouseenter .carousel': 'showTooltip',
      'mouseleave .carousel': 'hideTooltip'
    },
    showPhotoById: function(photoId) {
      var view = this.options.inline ? this.modalView : this;
      var $item = view.$('img.ss_img[data-photo-id='+photoId+']').closest('.item'),
          $items = $item.parent().children(),
          idx = $items.index($item);
      if(idx === -1) return;
      view.carousel(idx);
      if(!this.options.inline) this.showModal();
    },
    delegateCarouselEvents: function() {
      this.$('.carousel')
        .on('slid.bs.carousel', this.imageLoader)
        .on('slid.bs.carousel', this.highlightActiveOnMap)
        .on('slid.bs.carousel', this.showTooltipIfMouseover)
    },
    carousel: function() {
      this.$('.carousel').carousel.apply(this.$('.carousel'), arguments);
    },
    showTooltip: function() {
      this._mouseover = true;
      this.$('.item.active a.popup_photo_modal').tooltip('show');
    },
    hideTooltip: function() {
      this._mouseover = false;
      this.$('.item.active a.popup_photo_modal').tooltip('hide');
    },
    showTooltipIfMouseover: function() {
      if(this._mouseover) {
        this.$('a.popup_photo_modal').tooltip('hide');
        this.showTooltip();
      }
    },

    showModal: function() {
      var slideTo = this.$('.item').index(this.$('.item.active'));

      if (rwgps.gallery) {
        rwgps.gallery({
          photos: this.photos,
          readonly: !this.options.canEdit,
          defaultActive: slideTo,
          photosetId: this.photosetId,
          parentType: this.options.parentType,
          parentId: this.options.parentId,
          coverId: this.options.coverId
        })
      } else {
        this.modalView.show(slideTo);
      }
    },
    setupUploader: function() {
      var $container = this.options.inline ? this.modalView.$el : this.$el,
          $parent = $container.parent(),
          view = this;
      $container.append(this.uploaderTemplate({
        cta: T.t('add_photos')
      }));

      function photoUploaded(photo) {
        if(photo.captured_at)
          photo.captured_at = rwgps.DateExt.parse(photo.captured_at);
        view.photos.push(photo);
        view.trigger("photo:added", photo);
      }
      function photosUploaded() {
        if(view.options.inline) {
          // teardown
          view.modalView.undelegateEvents();
          view.modalView.$el.remove();

          // rebuild
          view.modalView.render();
          view.modalView.delegateEvents();
          $parent.html(view.modalView.$el);

          view.setupUploader();
        } else {
          // teardown
          view.hideTooltip();
          view.undelegateEvents();
          view.$el.remove();
          view.modalView.undelegateEvents();
          view.modalView.$el.remove();

          // rebuild
          view.render();
          view.delegateEvents();
          $parent.html(view.$el);
          view.modalView.render();
          view.modalView.delegateEvents();
          view.modalView.$el.appendTo('body');

          view.setupUploader();
        }
      }
      var $uploader = $parent.find('.photo_uploader');
      var data = rwgps.csrfParams();
      if(this.options.parentType && this.options.parentId) {
        data.parent_type = this.options.parentType;
        data.parent_id = this.options.parentId;
      }
      if(this.photosetId)
        data.photoset_id = this.photosetId;
      var fileUploadOpts = {
        dataType: 'json',
        url: '/upload/photos',
        type: 'post',
        paramName: 'Filedata',
        sequentialUploads: true,
        maxFileSize: 15000000,
        formData: function() {
          return _.map(data, function(val, key) {
            return {name: key, value: val};
          });
        },
        add: function(e, f) {
          var toKeep = [];
          //TODO: alert user file has wrong extension
          _.each(f.files, function(file) {
            if(rwgps.imageExtRegEx.test(file.name)) {
              toKeep.push(file);
            } else {
              trace("File failed regex match: " + file.name);
            }
          });
          if(toKeep.length > 0) {
            f.files = toKeep;

            if(!view.photosetId && !view.options.parentId && !view.options.photosetDisabled) {
              if(!view.createPhotoset) {
                view.createPhotoset = $.post("/photosets")
                  .success(function(photoset) {
                    data.photoset_id = photoset.id;
                    view.photosetId = photoset.id;
                  });
              }
              view.createPhotoset.success(function() { f.submit(); });
            } else {
              f.submit();
            }
          } else {
            //TODO: handle errors
            trace("No valid photos");
          }
        },
        start: function() {
          $container.find('.below_image').hide();
          $uploader.find('.fileinput-button').hide();
          $uploader.find('.progress').show();
          window.$u = $uploader;
          view.trigger('upload:start');
        },
        stop: function() {
          $uploader.find('.progress').hide();
          $uploader.find('.fileinput-button').show();
          photosUploaded();
          view.trigger('upload:complete');
        },
        progressall: function (e, data) {
          var progress = parseInt(data.loaded / data.total * 100, 10);
          $uploader.find('.progress .progress-bar').css( 'width', progress + '%');
        },
        done: function(e, data) {
          photoUploaded(data.result.photo);
        },
        fail: function(e, data) {
          //TODO: actual error handling
          $uploader.find('.progress').hide();
          $uploader.find('.fileinput-button').show();
          if(data.jqXHR && data.jqXHR.responseText) {
            var res = $.parseJSON(data.jqXHR.responseText);
            trace("Something went wrong: " + res.error);
          } else {
            trace(T.t("something_went_wrong"));
          }
        }
      };
      var $uploader_input = $uploader.find('.photos_upload');
      if($uploader_input.fileupload)
        $uploader_input.fileupload(fileUploadOpts);
    },
    render: function() {
      if(this.photos.length > 0) {
        this.$el.html(this.template({
            carouselId: this.carouselId
        }));
        var $indicators = this.$('.carousel-indicators'),
            $items = this.$('.carousel-inner');
        _.each(this.photos, function(photo, i) {
          $indicators.append(this.indicatorTemplate({
            carouselId: this.carouselId,
            slideTo: i,
            photoId: photo.id
          }));
          $items.append(this.itemTemplate({
            photo: photo
          }));
        }, this);
        $indicators.find('li').first().addClass('active');
        $items.find('.item').first().addClass('active');
        $items.find('img.ss_img').each(function() {
          $(this).attr('src', $(this).data('lazy-src'));
        });
        // set up tooltips on hover
        this.$('a.popup_photo_modal').tooltip({
          container: 'body',
          trigger: 'manual',
          animation: false
        });
        this.carousel({interval: 0});
        this.delegateCarouselEvents();

        // hide left/right controls until first image is loaded
        if(this.photos.length > 1) {
          this.$('.carousel-control').hide();
          var $img = this.$('.item.active img.ss_img');
          if($img.get(0).height > 0)
            this.$('.carousel-control').show();
          else {
            var view = this;
            $img.on('load', function() {
              view.$('.carousel-control').show();
            });
          }
        } else {
          this.$('.carousel-control').hide();
          this.$('.carousel-indicators').hide();
        }
      }
    }
  });
  PhotosModalView =
  CarouselView.extend({
    id: function() { return _.uniqueId("photosview_"); },
    className: function() {
      if(this.options.modal) {
        return 'modal photo_modal fade';
      } else {
        return 'photo_inline';
      }
    },
    template: rwgps.templates.photos.modalSlideshow,
    indicatorTemplate: rwgps.templates.photos.modalSlideshowIndicator,
    itemTemplate: rwgps.templates.photos.modalSlideshowItem,
    shareBarTemplate: rwgps.templates.photos.shareBar,
    initialize: function() {
      _.bindAll(this, 'globalArrowNav', 'resizeHandler', 'imageLoader', 'highlightActiveOnMap', 'verticallyCenterImage', 'updateRoute', 'clearRoute', 'enableGlobalArrowNav', 'disableGlobalArrowNav', 'enableResizeHandler', 'disableResizeHandler', 'syncMiniSlideshowPosition', 'hideOnEscape');
      this.throttledResizeHandler = _.throttle(this.resizeHandler);

      this.parentType = this.options.parentType;
      this.parentId = this.options.parentId;
      this.photosView = this.options.photosView;
      this.photos =      this.photosView ? this.photosView.photos : this.processPhotos(this.options.photos);
      this.photosetId =  this.photosView ? this.photosView.photosetId : this.options.photosetId;
      this.canEdit =     this.photosView ? this.photosView.canEdit : this.options.canEdit;
      this.hideSharing = this.photosView ? this.photosView.options.hideSharing : true;
      this.carouselId = _.uniqueId("photosview_");
    },
    events: {
      'click .carousel-control.left': 'prev',
      'click .carousel-control.right': 'next',
      'click .edit_actions .set_highlight': 'setHighlight',
      'click .edit_actions .rotate_ccw': 'rotateCcw',
      'click .edit_actions .rotate_cw': 'rotateCw',
      'click .edit_actions .remove': 'removeOnConfirm',
      'click .image_container': 'next',

      'click .share_bar_share_link': 'closeModal',

      'click .can_modify': 'enableCaptionEditor',
      'click .caption.editing .cancel': 'cancelCaptionEdit',
      'click .caption.editing .save': 'saveCaptionEdit',
      'keypress .caption.editing input': 'saveCaptionEditOnEnter'
    },
    closeModal: function() {
      if(this.options.modal) {
        this.$el.modal('hide');
      }
    },
    delegateModalEvents: function() {
      this.$el
        .on('shown.bs.modal', this.verticallyCenterImage)
        .on('shown.bs.modal', this.imageLoader)
        .on('shown.bs.modal', this.enableGlobalArrowNav)
        .on('shown.bs.modal', this.cacheScrollTop)
        .on('hide.bs.modal', this.disableGlobalArrowNav)
        .on('show.bs.modal', this.enableResizeHandler)
        .on('shown.bs.modal', this.resizeHandler)
        .on('shown.bs.modal', this.updateRoute)
        .on('hide.bs.modal', this.clearRoute)
        .on('hide.bs.modal', this.disableResizeHandler)
        .on('hide.bs.modal', this.syncMiniSlideshowPosition)
        .on('hide.bs.modal', this.restoreScrollTop);
      $('body').on('keyup', this.hideOnEscape);
    },
    delegateCarouselEvents: function() {
      this.$('.carousel')
        .on('slid.bs.carousel', this.imageLoader)
        .on('slid.bs.carousel', this.highlightActiveOnMap)
        .on('slid.bs.carousel', this.verticallyCenterImage)
        .on('slid.bs.carousel', this.updateRoute)
    },
    hideOnEscape: function(e) {
      if(e.keyCode === 27)
        this.closeModal();
    },
    clearRoute: function() {
      if(PhotosView.router)
        PhotosView.router.navigate("", {replace: true});
    },
    updateRoute: function() {
      if(PhotosView.router)
        PhotosView.router.navigate("photos/" + this.activePhotoId(), {replace: true});
    },
    cacheScrollTop: function() {
      this._pageScrollTop = $(window).scrollTop();
    },
    restoreScrollTop: function() {
      $(window).scrollTop(this._pageScrollTop);
    },
    cancelCaptionEdit: function(e) {
      var $caption = this.$('.item.active .caption.can_modify');
      $caption.html(this.prevCaptionHtml);
      $caption.removeClass('editing');
      e.stopPropagation();
    },
    saveCaptionEditOnEnter: function(e) {
      if(e.keyCode == 13) {
        this.saveCaptionEdit();
        return false;
      }
    },
    saveCaptionEdit: function(e) {
      var $caption = this.$('.item.active .caption.can_modify');
      var caption = $caption.find('input').val();
      $caption.html('').text(caption);
      var photoId = this.activePhotoId();
      var params = { photos: {} };
      params.photos[photoId] = {caption: caption};
      Application.preventSpinner();
      $.post('/photos/update_set', params);
      $caption.removeClass('editing');
      if(e)
        e.stopPropagation();
    },
    enableCaptionEditor: function() {
      var $caption = this.$('.item.active .caption.can_modify');
      if($caption.hasClass('editing')) return; // already editing.

      this.prevCaptionHtml = $caption.html();
      var caption = $caption.find('.nocaption').size() ? '' : $caption.text();
      $caption.addClass('editing');
      $caption.html('<form class="form-inline"><input type="text" maxlength="255"><a href="javascript:;" class="btn btn-default save">Save</a><a href="javascript:;" class="btn btn-default cancel">Cancel</a></form>');
      $caption.find('input').val(caption).focus().select();
      $caption.find('form').on('submit', function() {
        return false;
      });
    },

    enableResizeHandler: function() {
      $(window).on('resize', this.throttledResizeHandler).resize();
    },
    disableResizeHandler: function() {
      $(window).off('resize', this.throttledResizeHandler);
    },
    // make the slideshow scale to size of browser
    resizeHandler: function() {
      var containerHeight, containerWidth, imageContainerHeight;
      if (this.photos.length == 0) {
        containerWidth = this.$el.parent().width();
        imageContainerHeight = 0;
        containerHeight = 100;
      } else if (this.options.modal) {
        var availableWidth = $(window).width(),
            availableHeight = $(window).height();
        containerWidth = availableWidth * 0.8;
        containerHeight = availableHeight * 0.95;
        imageContainerHeight = containerHeight - 150;
      } else {
        containerWidth = this.$el.parent().width();
        imageContainerHeight = containerWidth * 0.75;
        containerHeight = imageContainerHeight + 100;
      }
      this.$el.find('.modal-dialog').width(containerWidth);
      this.$el.find('.modal-content').height(containerHeight);
      this.$('.carousel-control').height(imageContainerHeight);
      this.$('.image_container').height(imageContainerHeight);
      this.verticallyCenterImage();
    },

    carousel: function() {
      this.$('.carousel').carousel.apply(this.$('.carousel'), arguments);
    },
    // navigate to next/prev image with arrow keys
    globalArrowNav: function(e) {
      if($(e.target).is('input')) return;
      if(e.keyCode === 37) {
        this.prev();
      } else if(e.keyCode === 39) {
        this.next();
      }
    },
    enableGlobalArrowNav: function() {
      $('body').on('keydown', this.globalArrowNav);
    },
    disableGlobalArrowNav: function() {
      $('body').off('keydown', this.globalArrowNav);
    },
    show: function(slideTo) {
      this.$el.modal();
      this.carousel({interval: 0});
      this.carousel(slideTo);
    },
    showById: function(photoId) {
      var $item = this.$('img.ss_img[data-photo-id='+photoId+']').closest('.item'),
          $items = $item.parent().children(),
          idx = $items.index($item);
      if(idx === -1) return;
      this.show(idx);
    },
    syncMiniSlideshowPosition: function() {
      if(!this.photosView) return;
      var $active = this.$('.item.active'),
          $items = $active.parent().children(),
          idx = $items.index($active);
      // in case the active photo was deleted and was idx 0, need to slide forward first (bug in bootstrap carousel)
      // no easy way to detect this so doing it if the one that was showing was deleted, regardless of index (doesnt hurt)
      if(this.photosView.$('.item.active').size() == 0) {
        this.photosView.next();
      }
      this.photosView.carousel(idx);
    },
    setHighlight: function() {
      var view = this,
          photoId = this.activePhotoId();
      $.post('/photosets/' + this.photosetId + '/photo/' + photoId + '/set_highlight', {
        parent_type: this.parentType,
        parent_id: this.parentId
      }, function() {
        view.$('.item.active .set_highlight').slideUp();
      });
    },
    rotateCcw: function() { this.rotate(-90); },
    rotateCw: function() { this.rotate(90); },
    rotate: function(degrees) {
      var view = this,
          photoId = this.activePhotoId();
      $.post('/photos/' + photoId + '/rotate.json', {
        degrees: degrees
      }, function() {
        $('img.ss_img[data-photo-id=' + photoId + ']').each(function() {
          if($(this).attr('src')) {
            $(this).attr('src', $(this).attr('src') + '?1'); // force reload
          }
        });
        view.verticallyCenterImage();
      });
    },
    removeOnConfirm: function() {
      if(confirm("Are you sure you want to delete this photo?")) {
        this.remove();
      }
    },
    remove: function() {
      var photoId = this.activePhotoId();
      $.post('/photos/' + photoId + '.json', {_method: 'delete'});
      // assume success, act now.  move to next in carousel, then remove indicator and item
      // from modal slideshow as well as mini slideshow
      this.next();
      $('img.ss_img[data-photo-id=' + photoId + ']').closest('.item').remove();
      $('.carousel-indicators li[data-photo-id=' + photoId + ']').each(function() {
        // since we deleted a photo, all subsequent photos need to have their indexes updated.
        $(this).nextAll().each(function() {
          $(this).attr('data-slide-to', $(this).attr('data-slide-to') - 1);
        })
      }).remove();
      // kill slideshows if they no longer have any photos, and close modal
      var view = this;
      if(this.options.modal) {
        $('.mini_slideshow').each(function() {
          if(!$(this).find('.item').size()) {
            $(this).html('');
            // and kill the modal
            view.$el.modal('hide');
          }
        });
      } else {
        $('.photo_inline>.inner').each(function() {
          if(!$(this).find('.item').size()) {
            $(this).html('');
          }
        });
      }
      // if it is on the map, remove it
      if(Routes && Routes.activeMap) {
        var markers = Routes.activeMap.imageMarkers;
        if(markers && markers[photoId]) {
          markers[photoId].setMap(null);
          if(Routes.activeMap.selectedImageMarker === markers[photoId]) {
            Routes.activeMap.selectedImageMarker.setMap(null);
            delete Routes.activeMap.selectedImageMarker;
          }
          delete markers[photoId];
        }
      }
      var photo;
      // finally, remove from photos collection
      for(var i=0; i < this.photos.length; i++) {
        if(this.photos[i].id == photoId) {
          photo = this.photos[i];
          this.photos.splice(i, 1);
          break;
        }
      }
      if(this.photosView)
        this.photosView.trigger("photo:deleted", photo);
    },

    // for images that are constrained by width, vertically align if or when they are loaded.
    verticallyCenterImage: function() {
      var $img = this.$('.item.active img.ss_img');
      if(!$img.size()) return;

      if($img.get(0).height > 0)
        this._verticallyCenterImage($img);
      else {
        $img.off('load');
        var view = this;
        $img.on('load', function() {
          $img.data('loaded', true);
          view._verticallyCenterImage($img);
        });
      }
    },
    // actually perform the centering -- the image is loaded!
    _verticallyCenterImage: function($img) {
      var img = $img.get(0),
          w = img.width,
          h = img.height,
          $imgContainer = this.$('.item.active .image_container'),
          maxW = $imgContainer.width(),
          maxH = $imgContainer.height();
      if(maxW === 0) {
        // modal isn't loaded yet, so don't do anything stupid like move the image based on a max width of 0
        return;
      }

      // We might actually know the dimensions, instead of reading them from the DOM where we may or may not have actually loaded the image yet
      if ($img.attr('data-photo-id')) {
        var photoId = parseInt($img.data('photo-id'), 10);
        var photo = _.findWhere(this.photos, {id: photoId});
        if (photo && _.has(photo, 'height') && _.has(photo, 'width')) {
          w = photo.width;
          h = photo.height;
        }
      }

      if(w < maxW && h < maxH) {
        // the image fits within our viewing area, so just center it.
        $img.css({marginTop: (maxH - h)/2 + 'px'});
      } else if(w / h > maxW / maxH) {
        //constrained on width
        var displayHeight = h * maxW / w;
        $img.css({marginTop: (maxH - displayHeight)/2 + 'px'});
      } else {
        $img.css({marginTop: 0});
      }
      // done! let's show the image now.
      $img.css({visibility: 'visible'});
    },
    render: function() {
      this.$el.html(this.template({
        carouselId: this.carouselId,
        modal: this.options.modal
      }));
      var $indicators = this.$('.carousel-indicators'),
          $items = this.$('.carousel-inner');
      _.each(this.photos, function(photo, i) {
        $indicators.append(this.indicatorTemplate({
          carouselId: this.carouselId,
          slideTo: i,
          photoId: photo.id
        }));
        var uri = "http://" + window.location.host + window.location.pathname + "#photos/" + photo.id;
        var itemTemplateOpts = {
          photo: photo,
          canEdit: this.canEdit,
          belongsToPhotoset: this.photosetId,
          shareBar: ''
        };
        if(!this.hideSharing) {
          itemTemplateOpts.shareBar = this.shareBarTemplate({
            assetType: "photo",
            assetId: photo.id,
            uri: uri,
            tweet: "Check out this cool photo: " + uri
          });
        }
        $items.append(this.itemTemplate(itemTemplateOpts));
      }, this);
      $indicators.find('li').first().addClass('active');
      $items.find('.item').first().addClass('active');
      this.carousel({interval: 0});
      this.delegateCarouselEvents();

      if(this.photos.length === 1) {
        this.$('.carousel-control').hide();
        this.$('.carousel-indicators').hide();
      }

      if(this.options.modal) {
        this.delegateModalEvents();
      } else {
        $items.find('img.ss_img').slice(0, 2).each(function() {
          $(this).attr('src', $(this).data('lazy-src')).css({visibility: 'visible'});
        });
        this.enableResizeHandler();
        // if there arent any photos, clear the carousel out.
        if(!this.photos.length) {
          this.$('.inner').html('');
        }
      }
    }
  });

  PhotosRouter = Backbone.Router.extend({
    routes: {
      "photos/:id": "photo"
    }
  });

  PhotosView.viewsByPhotoIds = {};
  PhotosView.router = new PhotosRouter;
  PhotosView.router.on("route:photo", function(photoId) {
    if(PhotosView.viewsByPhotoIds[photoId]) {
      PhotosView.viewsByPhotoIds[photoId].showPhotoById(photoId);
    } else {
      PhotosView.attemptedPhotoId = photoId;
    }
  });
  PhotosView.registerPhotos = function(photos, view, noClobber = false) {
    for(var i = 0; i < photos.length; i++) {
      if (!noClobber || !PhotosView.viewsByPhotoIds[photos[i].id]) {
        PhotosView.viewsByPhotoIds[photos[i].id] = view;
      }
      if(PhotosView.attemptedPhotoId && PhotosView.attemptedPhotoId == photos[i].id) {
        PhotosView.attemptedPhotoId = undefined;
        view.showPhotoById(photos[i].id);
      }
    }
  }

  // clean up photosview-managed DOM items when a photo is deleted outside this
  // file
  PhotosView.removeById = function (photoId) {
    const photosView = PhotosView.viewsByPhotoIds[photoId]
    if (!photosView) { return false }
    const photo = photosView.photos.find(p => p.id === photoId)
    if (!photo) { return false }
    if (photosView.activePhotoId() === photoId) { photosView.next() }

    // used by the map to remove photos from POIs
    photosView.trigger('photo:deleted', photo)

    // remove from the underlying datasource on the resource gallery
    photosView.photos = photosView.photos.filter(p => p.id !== photoId)

    // remove indicator and item from mini slideshows
    $('img.ss_img[data-photo-id=' + photoId + ']').closest('.item').remove()
    // kill slideshows if they no longer have any photos, and close modal
    $('.mini_slideshow').each(function() {
      if(!$(this).find('.item').size()) {
        $(this).html('');
      }
    })
    return true
  }

  PhotosView.PhotosModalView = PhotosModalView;
  module.exports = PhotosView;
})();



// WEBPACK FOOTER //
// ./public/javascripts/rwgps/views/photos.js